import { useForm } from 'react-hook-form';

import { State } from '@/types';

import { TFeaturedPeopleForm } from '../types';

export function useFeaturedPeopleDrawerFormState() {
  const initialValues: Partial<TFeaturedPeopleForm> = {
    name: '',
    description: null,
    surname: '',
    main_logo: '',
    logos: [],
    alias: null,
    state: State.Inactive,
    logos_presigned_urls: [],
    active_detection: false,
  };
  const form = useForm<TFeaturedPeopleForm>({
    mode: 'all',
    defaultValues: initialValues,
  });

  return { form, initialValues };
}
